<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">I dedicate this book to my family, for all their support and encouragement. I wouldn’t be a good author without their support and understanding.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7be4d439